module.exports = __webpack_public_path__ + "static/furniture-products-by-category-sorting-tabs-section-0ff2e13f046dfc765dcf48f934938fe1.png";